export default __webpack_public_path__ + "static/media/no_results2.ada07153.svg";